import {
  useInfiniteQuery,
  type InfiniteData,
  type UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import {
  getRequirementPositions,
  type GetRequirementPositionsRequest,
  type GetRequirementPositionsResponse,
} from 'api/requirements/getRequirementPositions'
import { requirementKeys } from './keys'

type UseRequirementPositionsQueryKey = ReturnType<
  typeof requirementKeys.positionsList
>
type UseRequirementPositionsQueryPageParam = string | undefined

type UseRequirementPositionsQueryOptions = Partial<
  UseInfiniteQueryOptions<
    GetRequirementPositionsResponse,
    Error,
    InfiniteData<
      GetRequirementPositionsResponse,
      UseRequirementPositionsQueryPageParam
    >,
    GetRequirementPositionsResponse,
    UseRequirementPositionsQueryKey,
    UseRequirementPositionsQueryPageParam
  >
>

export function useRequirementPositionsQuery(
  request: Omit<GetRequirementPositionsRequest, 'cursor' | 'direction'>,
  options: UseRequirementPositionsQueryOptions = {}
) {
  return useInfiniteQuery<
    GetRequirementPositionsResponse,
    Error,
    InfiniteData<
      GetRequirementPositionsResponse,
      UseRequirementPositionsQueryPageParam
    >,
    UseRequirementPositionsQueryKey,
    UseRequirementPositionsQueryPageParam
  >({
    ...options,
    queryKey: requirementKeys.positionsList(request),
    initialPageParam: undefined,
    queryFn: ({ pageParam }) =>
      getRequirementPositions({
        ...request,
        direction: 'next',
        ...(pageParam ? { cursor: pageParam } : {}),
      }),
    getNextPageParam: (lastPage) => {
      if (lastPage.items.length === 0) {
        return undefined
      }
      return lastPage.nextCursor ?? undefined
    },
  })
}
